import React, { useContext, useState } from 'react'
import Button from '@/components/Button'
import { Context } from '@/components/Context'
import { shortAddress } from '@/utils/shortenAddress'
import { ArtData } from '@/database/art'
import { ChatMessage, WebSocketMessage } from '@/types/websocket'

const extractTags = (message: string, artData?: ArtData): string[] => {
    // Regex to capture @number or #number patterns
    const pattern = /[@#]\d+/g
    const matches: string[] = message.match(pattern) || []

    // Add specific artData id if present or fallback to a default
    if (artData?.tokenId) {
        matches.push(`#` + artData.tokenId)
    } else if (artData?.art.id) {
        matches.push(`@` + artData.art.id)
    } else {
        matches.push('@general')
    }

    // Return the unique tags
    return Array.from(new Set(matches))
}

const ChatFooter = ({ artData }: { artData?: ArtData }) => {
    const [message, setMessage] = useState('')
    const { accountSignature, webSocketService, socketId, currentAccount } = useContext(Context)
    const handleTyping = () => {
        if (webSocketService.isConnected() && currentAccount) {
            const typingMessage: WebSocketMessage = {
                type: 'typing',
                data: shortAddress(currentAccount),
            }
            webSocketService.send(typingMessage)
        }
    }
    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            handleSendMessage(event)
        }
        handleTyping()
    }

    const handleSendMessage = (event: React.FormEvent | React.KeyboardEvent<HTMLTextAreaElement>) => {
        event.preventDefault()
        if (webSocketService.isConnected() && message.trim() && accountSignature && currentAccount && socketId) {
            const chatMessage: ChatMessage = {
                id: 0,
                text: message,
                name: shortAddress(currentAccount),
                messageId: `${webSocketService.getUrl()}${Math.random()}`,
                timestamp: Math.floor(Date.now() / 1000),
                socketId: socketId,
                tags: extractTags(message, artData),
            }

            const wsMessage: WebSocketMessage<ChatMessage> = {
                type: 'message',
                account: currentAccount,
                signature: accountSignature,
                data: chatMessage,
            }

            webSocketService.send(wsMessage)
        }
        setMessage('')
    }

    return (
        <div>
            <form className="margin-left menu-wrapper-row" onSubmit={handleSendMessage}>
                <textarea
                    placeholder={accountSignature ? 'Your message' : 'Connect first'}
                    className="small width300 height20 padding-zero"
                    value={message}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(e.target.value)}
                    onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => handleKeyDown(e)}
                    maxLength={200}
                />
                <Button
                    btnName="Send"
                    classStyles="small height20 nav__medium width50"
                    handleClick={handleSendMessage}
                    disabled={!accountSignature}
                    cancelBg={undefined}
                />
            </form>
        </div>
    )
}

export default ChatFooter
